<template>
  <div v-if="isShow" id="image-modal" class="modal">
    <span class="close">&times;</span>
    <div class="modal-content">
      <div>
        <svg @click="previousContent()" v-if="images?.length > 1" class="arrow-left" width="48" height="48" viewBox="0 0 48 48" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0V0ZM34.5 22.5C34.8978 22.5 35.2794 22.658 35.5607 22.9393C35.842 23.2206 36 23.6022 36 24C36 24.3978 35.842 24.7794 35.5607 25.0607C35.2794 25.342 34.8978 25.5 34.5 25.5H17.121L23.562 31.938C23.7015 32.0775 23.8121 32.243 23.8876 32.4252C23.963 32.6075 24.0019 32.8028 24.0019 33C24.0019 33.1972 23.963 33.3925 23.8876 33.5748C23.8121 33.757 23.7015 33.9225 23.562 34.062C23.4225 34.2015 23.257 34.3121 23.0748 34.3876C22.8925 34.463 22.6972 34.5019 22.5 34.5019C22.3028 34.5019 22.1075 34.463 21.9252 34.3876C21.743 34.3121 21.5775 34.2015 21.438 34.062L12.438 25.062C12.2983 24.9227 12.1875 24.7571 12.1119 24.5749C12.0362 24.3927 11.9973 24.1973 11.9973 24C11.9973 23.8027 12.0362 23.6073 12.1119 23.4251C12.1875 23.2429 12.2983 23.0773 12.438 22.938L21.438 13.938C21.7197 13.6563 22.1017 13.4981 22.5 13.4981C22.8983 13.4981 23.2803 13.6563 23.562 13.938C23.8437 14.2197 24.0019 14.6017 24.0019 15C24.0019 15.3983 23.8437 15.7803 23.562 16.062L17.121 22.5H34.5Z" fill="white"/>
        </svg>
      </div>
      <div class="modal-content-container">
        <div class="close-modal" @click="close()">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 3C8.83187 3 3 8.83187 3 16C3 23.1681 8.83187 29 16 29C23.1681 29 29 23.1681 29 16C29 8.83187 23.1681 3 16 3ZM20.7069 19.2931C20.8036 19.3851 20.881 19.4954 20.9345 19.6178C20.9879 19.7401 21.0163 19.8718 21.018 20.0053C21.0197 20.1388 20.9947 20.2712 20.9444 20.3949C20.8941 20.5185 20.8196 20.6308 20.7252 20.7252C20.6308 20.8196 20.5185 20.8941 20.3949 20.9444C20.2712 20.9947 20.1388 21.0197 20.0053 21.018C19.8718 21.0163 19.7401 20.9879 19.6178 20.9345C19.4954 20.881 19.3851 20.8036 19.2931 20.7069L16 17.4144L12.7069 20.7069C12.5178 20.8865 12.2661 20.9852 12.0053 20.9818C11.7445 20.9785 11.4954 20.8734 11.311 20.689C11.1266 20.5046 11.0215 20.2555 11.0182 19.9947C11.0148 19.7339 11.1135 19.4822 11.2931 19.2931L14.5856 16L11.2931 12.7069C11.1135 12.5178 11.0148 12.2661 11.0182 12.0053C11.0215 11.7445 11.1266 11.4954 11.311 11.311C11.4954 11.1266 11.7445 11.0215 12.0053 11.0182C12.2661 11.0148 12.5178 11.1135 12.7069 11.2931L16 14.5856L19.2931 11.2931C19.4822 11.1135 19.7339 11.0148 19.9947 11.0182C20.2555 11.0215 20.5046 11.1266 20.689 11.311C20.8734 11.4954 20.9785 11.7445 20.9818 12.0053C20.9852 12.2661 20.8865 12.5178 20.7069 12.7069L17.4144 16L20.7069 19.2931Z" fill="white"/>
          </svg>
        </div>
        <img class="image" v-if="images.length > 0" referrerpolicy="no-referrer" :src="showedContent" alt="preview" id="img01">
        <div class="footer-content">
          <span>{{ contentName }}</span>
          <a @click="downloadFile(contentName)" class="download-content">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.71 6.29C22.617 6.19627 22.5064 6.12188 22.3846 6.07111C22.2627 6.02034 22.132 5.9942 22 5.9942C21.868 5.9942 21.7373 6.02034 21.6154 6.07111C21.4936 6.12188 21.383 6.19627 21.29 6.29L20 7.59V2C20 1.73478 19.8946 1.48043 19.7071 1.29289C19.5196 1.10536 19.2652 1 19 1C18.7348 1 18.4804 1.10536 18.2929 1.29289C18.1054 1.48043 18 1.73478 18 2V7.59L16.71 6.29C16.5217 6.1017 16.2663 5.99591 16 5.99591C15.7337 5.99591 15.4783 6.1017 15.29 6.29C15.1017 6.4783 14.9959 6.7337 14.9959 7C14.9959 7.2663 15.1017 7.5217 15.29 7.71L18.29 10.71C18.3851 10.801 18.4972 10.8724 18.62 10.92C18.7397 10.9729 18.8691 11.0002 19 11.0002C19.1309 11.0002 19.2603 10.9729 19.38 10.92C19.5028 10.8724 19.6149 10.801 19.71 10.71L22.71 7.71C22.8037 7.61704 22.8781 7.50644 22.9289 7.38458C22.9797 7.26272 23.0058 7.13201 23.0058 7C23.0058 6.86799 22.9797 6.73728 22.9289 6.61542C22.8781 6.49356 22.8037 6.38296 22.71 6.29ZM19 13C18.7348 13 18.4804 13.1054 18.2929 13.2929C18.1054 13.4804 18 13.7348 18 14V14.38L16.52 12.9C15.9974 12.3815 15.2911 12.0906 14.555 12.0906C13.8189 12.0906 13.1126 12.3815 12.59 12.9L11.89 13.6L9.41 11.12C8.88012 10.6156 8.17657 10.3343 7.445 10.3343C6.71343 10.3343 6.00988 10.6156 5.48 11.12L4 12.6V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H13C13.2652 6 13.5196 5.89464 13.7071 5.70711C13.8946 5.51957 14 5.26522 14 5C14 4.73478 13.8946 4.48043 13.7071 4.29289C13.5196 4.10536 13.2652 4 13 4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V14C20 13.7348 19.8946 13.4804 19.7071 13.2929C19.5196 13.1054 19.2652 13 19 13ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V15.43L6.9 12.53C7.04691 12.39 7.24206 12.3119 7.445 12.3119C7.64794 12.3119 7.84309 12.39 7.99 12.53L11.16 15.7L15.46 20H5ZM18 19C17.9986 19.1914 17.9354 19.3773 17.82 19.53L13.31 15L14.01 14.3C14.0817 14.2268 14.1673 14.1687 14.2617 14.129C14.3561 14.0893 14.4576 14.0689 14.56 14.0689C14.6624 14.0689 14.7639 14.0893 14.8583 14.129C14.9527 14.1687 15.0383 14.2268 15.11 14.3L18 17.21V19Z" fill="#21409A"/>
            </svg>
             <span>{{ downloading ? 'Mengunduh...' : 'Download' }}</span>
          </a>
        </div>
      </div>
      <div>
        <svg @click="nextContent()" v-if="images?.length > 1" class="arrow-right" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0V0ZM13.5 22.5C13.1022 22.5 12.7206 22.658 12.4393 22.9393C12.158 23.2206 12 23.6022 12 24C12 24.3978 12.158 24.7794 12.4393 25.0607C12.7206 25.342 13.1022 25.5 13.5 25.5H30.879L24.438 31.938C24.2985 32.0775 24.1879 32.243 24.1124 32.4252C24.037 32.6075 23.9981 32.8028 23.9981 33C23.9981 33.1972 24.037 33.3925 24.1124 33.5748C24.1879 33.757 24.2985 33.9225 24.438 34.062C24.5775 34.2015 24.743 34.3121 24.9252 34.3876C25.1075 34.463 25.3028 34.5019 25.5 34.5019C25.6972 34.5019 25.8925 34.463 26.0748 34.3876C26.257 34.3121 26.4225 34.2015 26.562 34.062L35.562 25.062C35.7017 24.9227 35.8125 24.7571 35.8881 24.5749C35.9638 24.3927 36.0027 24.1973 36.0027 24C36.0027 23.8027 35.9638 23.6073 35.8881 23.4251C35.8125 23.2429 35.7017 23.0773 35.562 22.938L26.562 13.938C26.4225 13.7985 26.257 13.6879 26.0748 13.6124C25.8925 13.537 25.6972 13.4981 25.5 13.4981C25.3028 13.4981 25.1075 13.537 24.9252 13.6124C24.743 13.6879 24.5775 13.7985 24.438 13.938C24.2985 14.0775 24.1879 14.243 24.1124 14.4252C24.037 14.6075 23.9981 14.8028 23.9981 15C23.9981 15.1972 24.037 15.3925 24.1124 15.5748C24.1879 15.757 24.2985 15.9225 24.438 16.062L30.879 22.5H13.5Z" fill="white"/>
        </svg>
      </div>
    </div>
    <div id="modal-footer">

    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ImagePreviewComponent',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    startIndex: {
      type: Number,
      required: true,
      default: 0
    }
  },
  computed: {
    showedContent () {
      return this.images[this.aggregator].src
    },
    contentName () {
      return this.images[this.aggregator].name
    }
  },
  mounted () {
    window.addEventListener('keydown', (e) => {
      const key = e.key
      if (key === 'ArrowRight') this.nextContent()
      if (key === 'ArrowLeft') this.previousContent()
      if (key === 'Escape') {
        this.close()
        this.aggregator = 0
      }
    })
  },
  beforeUnmount () {
    window.removeEventListener('keydown', null)
  },
  data () {
    return {
      aggregator: 0,
      isShow: false,
      downloading: false
    }
  },
  methods: {
    previousContent () {
      if (this.aggregator === 0) {
        this.aggregator = this.images.length - 1
      } else {
        this.aggregator = this.aggregator - 1
      }
    },
    nextContent () {
      if (this.aggregator === this.images.length - 1) {
        this.aggregator = 0
      } else {
        this.aggregator = this.aggregator + 1
      }
    },
    show () {
      this.isShow = true
      document.body.style.overflow = 'hidden'
    },
    close () {
      this.isShow = false
      document.body.style.overflow = 'visible'
    },
    async downloadFile (name) {
      this.downloading = true
      const res = await axios.get('/content/document/publicfile', {
        params: {
          directory: this.$route.query?.directory,
          filename: name
        },
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
      this.downloading = false
    }
  },
  watch: {
    startIndex: {
      immediate: true,
      handler () {
        this.aggregator = this.startIndex
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  // padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  // overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  overflow: hidden !important;

  @media only screen and (max-width: 600px) {
    padding-top: 50px;
    overflow: hidden !important;
  }

  .modal-content {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    width: 100%;
    min-height: 400px;

    &-container {
      // background-color: #fff;
      display: flex;
      flex-direction: column;
      .close-modal {
        margin-bottom: 2rem;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
      }

      .image {
        place-self: center;
        image-resolution: from-image;
        background-size: cover;
        // min-width: 400px;
        max-height: 500px;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      }
      .footer-content {
        margin-top: 3rem;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        @media only screen and (max-width: 600px) {
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          min-height: 100px;
        }
        span {
          color: #fff;
        }
        a {
          display: flex;
          padding: .5rem .8rem;
          background-color: #CEDAFF;
          border-radius: 5px;
          border: 1px solid #21409A;
          justify-content: center;
          align-content: center;
          cursor: pointer;

          span {
            color: #21409A;
            font-weight: 600;
            margin-left: .4rem;
            margin-top: 2px;
          }
        }
      }
    }

    div {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      .arrow-left, .arrow-right {
        align-self: center;
        place-self: center;
        justify-content: flex-end;
        cursor: pointer;
      }
    }
  }
}
</style>
